var footer = {

    settings: {
        footer_accordion_menus: $('footer .menu-item-has-children'),
    },

    init: function() {
        if (this.settings.footer_accordion_menus.length) {
            this.footerAccordionMenus();
        }
    },

    footerAccordionMenus: function() {
        footer.settings.footer_accordion_menus.on('click', function(e) {
			if ($(window).width() < global_helpers.defaults.breakpoint_desktop) {
				e.stopPropagation();
				// Don't open menus on clicking titles
				if (e.target.nodeName != 'A') {
					$(this).find('.sub-menu').slideToggle(500);
				}
			}
		});
    }

};
footer.init();